import { render, staticRenderFns } from "./BatchView.vue?vue&type=template&id=603d27b6&"
import script from "./BatchView.vue?vue&type=script&lang=js&"
export * from "./BatchView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports